<template>
  <div class="chart-container">
    <canvas ref="canvas" />
  </div>
</template>

<script>
import { customAxios } from "@/utils/customAxios";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

const COLOR_ACTIVE = "#23305B";
const COLOR_INACTIVE = "#B0BEC5";

export default {
  name: "UserChart",
  data() {
    return {
      total: 0,
      active: 0,
      inactive: 0,
      chart: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  },
  methods: {
    async fetchData() {
      try {
        const res = await customAxios.get("/get-total-users");
        const body = res.data || {};
        this.total = Number(body.total_users) || 0;
        this.active = Number(body.active) || 0;
        this.inactive = Number(body.inactive) || Math.max(0, this.total - this.active);
        this.$nextTick(this.renderChart);
      } catch (err) {
        console.error("Error fetching users count:", err);
      }
    },
    renderChart() {
      const canvas = this.$refs.canvas;
      if (!canvas) return;
      if (this.chart) this.chart.destroy();
      const stale = Chart.getChart(canvas);
      if (stale) stale.destroy();

      const total = this.total;
      this.chart = new Chart(canvas, {
        type: "doughnut",
        data: {
          labels: ["Active (last 30 days)", "Inactive"],
          datasets: [
            {
              data: [this.active, this.inactive],
              backgroundColor: [COLOR_ACTIVE, COLOR_INACTIVE],
              borderColor: "#ffffff",
              borderWidth: 2,
              hoverOffset: 6,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutout: "72%",
          plugins: {
            legend: {
              position: "bottom",
              labels: {
                boxWidth: 10,
                boxHeight: 10,
                padding: 14,
                font: { size: 12 },
                color: "#5b6577",
                usePointStyle: true,
                pointStyle: "circle",
              },
            },
            tooltip: {
              backgroundColor: "#1f2540",
              titleColor: "#ffffff",
              bodyColor: "#ffffff",
              padding: 10,
              cornerRadius: 8,
              callbacks: {
                label: (ctx) => {
                  const v = ctx.raw || 0;
                  const pct = total ? ((v / total) * 100).toFixed(1) : "0.0";
                  return `${ctx.label}: ${v} (${pct}%)`;
                },
              },
            },
          },
        },
        plugins: [
          {
            id: "centerLabel",
            beforeDraw: (chart) => {
              const { ctx, chartArea } = chart;
              if (!chartArea) return;
              const cx = (chartArea.left + chartArea.right) / 2;
              const cy = (chartArea.top + chartArea.bottom) / 2;
              ctx.save();
              ctx.textAlign = "center";
              ctx.textBaseline = "middle";
              ctx.fillStyle = "#1f2540";
              ctx.font = "700 28px 'Kumbh Sans', system-ui, sans-serif";
              ctx.fillText(total.toLocaleString(), cx, cy - 8);
              ctx.font = "500 11px 'Kumbh Sans', system-ui, sans-serif";
              ctx.fillStyle = "#6b7383";
              ctx.fillText("USERS", cx, cy + 14);
              ctx.restore();
            },
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%;
}
canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>
